import React from "react"
import { IbanElement } from "@stripe/react-stripe-js"
import "../../styles/ibanFormStyles.css"
import StripeLogo from "../../assets/images/stripeLogo.png"
import WorkeyeLogo from "../../assets/images/WE_text_tick.png"
import { useStaticQuery, graphql } from "gatsby"

// Custom styling can be passed as options when creating an Element.
const IBAN_STYLE = {
  base: {
    color: "#32325d",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
    ":-webkit-autofill": {
      color: "#32325d",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
    ":-webkit-autofill": {
      color: "#fa755a",
    },
  },
}

const IBAN_ELEMENT_OPTIONS = {
  supportedCountries: ["SEPA"],
  // Elements can use a placeholder as an example IBAN that reflects
  // the IBAN format of your customer's country. If you know your
  // customer's country, we recommend that you pass it to the Element as the
  // placeholderCountry.
  placeholderCountry: "DE",
  style: IBAN_STYLE,
}

var showError = function (errorMsgText) {
  //changeLoadingState(false);
  var errorMsg = document.querySelector("#error-message")
  errorMsg.textContent = errorMsgText
  // setTimeout(function () {
  //   errorMsg.textContent = ""
  // }, 4000)
  document.getElementById("submit").style.display = "none"
}

export default function IbanForm({ onSubmit, disabled, planname, planamount }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulTestDrivePlans(sort: { fields: createdAt }) {
        nodes {
          taxText
        }
      }
    }
  `)
  const { allContentfulTestDrivePlans } = data

  return (
    <>
      <div className="sepa-form">
        <form onSubmit={onSubmit}>
          <div className="text-center" style={{ marginBottom: "20px" }}>
            <p>
              <h4>{planname}</h4>
            </p>
            <p>
              <h4>
                <b>{planamount}</b>
              </h4>
            </p>
            {allContentfulTestDrivePlans.nodes[0].taxText}
          </div>
          <div className="form-row inline">
            <div class="w-100 ">
              <div className="col">
                <label>
                  <div className="input-text">Full Name</div>
                  <div class="w-100 p-2">
                    <input
                      className="input-box"
                      name="accountholder-name"
                      placeholder="Jenny Rosen"
                      required
                    />
                  </div>
                </label>
              </div>
            </div>

            <div class="w-100">
              <div className="col">
                <label>
                  <div className="input-text">Email Address</div>
                  <div class="w-100 p-2">
                    <input
                      className="input-box"
                      name="email"
                      type="email"
                      placeholder="jenny.rosen@example.com"
                      required
                    />
                  </div>
                </label>
              </div>
            </div>

            <div class="w-100 ">
              <div className="col">
                <label>
                  <div className="input-text">Company Name</div>
                  <div class="w-100 p-2">
                    <input
                      className="input-box"
                      name="company-name"
                      placeholder="Example company"
                      required
                    />
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div class="w-100 p-3">
            <div className="form-column">
              <label>IBAN</label>
              <IbanElement
                options={IBAN_ELEMENT_OPTIONS}
                onChange={event => {
                  if (event.error) {
                    showError(event.error.message)
                  } else {
                    showError("")
                    document.getElementById("submit").style.display = "block"
                  }
                }}
              ></IbanElement>
            </div>
          </div>

          <div
            id="error-message"
            role="alert"
            class="text-danger pt-3 text-center"
          ></div>

          <center>
            <button
              id="submit"
              type="submit"
              className="btn btn-primary"
              disabled={disabled}
            >
              Pay
            </button>
          </center>
          {/* Display mandate acceptance text. */}
          <center>
            <div>
              <img
                src={StripeLogo}
                alt="Stripe Logo"
                classname="stripeLogo"
                height={100}
              />
              <img
                src={WorkeyeLogo}
                alt="Workeye Logo"
                classname="workeyeLogo"
                height={40}
              />
            </div>
          </center>
          <div class="w-100 p-3">
            <div className="mandate-acceptance">
              By providing your payment information and confirming this payment,
              you authorise (A) Workeye and Stripe, our payment service
              provider, to send instructions to your bank to debit your account
              and (B) your bank to debit your account in accordance with those
              instructions. As part of your rights, you are entitled to a refund
              from your bank under the terms and conditions of your agreement
              with your bank. A refund must be claimed within 8 weeks starting
              from the date on which your account was debited. Your rights are
              explained in a statement that you can obtain from your bank. You
              agree to receive notifications for future debits up to 2 days
              before they occur.
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
